import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { ISessionsStoreState } from "@gtmhub/sessions/redux/session-reducer";
import { reduxStoreContainer } from "@gtmhub/state-management/state-management.module";
import { EditionFeatureService } from "@webapp/accounts/services/edition-feature.service";
import { HttpActions } from "@webapp/core/abstracts/enums/http-actions.enum";
import { ReduxStoreObserver } from "@webapp/core/state-management/redux-store-observer";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { UsersFacade } from "@webapp/users/services/users-facade.service";
import { ISessionListItem, ISessionSelectorContext, ISessionData as ISessionSelectorData, ISessionTreeNode } from "../models/session-tree.model";
import { SessionListBuilder } from "./session-list-builders/session-list-builder";
import { SessionSelectorUtilsService } from "./session-selector-utils.service";
import { AbstractSessionTreeBuilder } from "./session-tree-builders/abstract-session-tree-builder";
import { SessionTreeBuilderFactory } from "./session-tree-builders/session-tree-builder-factory";

@Injectable({
  providedIn: "root",
})
export class SessionSelectorFacade {
  private tree: ISessionTreeNode[] = [];
  private list: ISessionListItem[] = [];
  private treeBuilder: AbstractSessionTreeBuilder;
  private listBuilder: SessionListBuilder;

  constructor(
    private usersFacade: UsersFacade,
    private sessionSelectorUtilsService: SessionSelectorUtilsService,
    featureTogglesFacade: FeatureTogglesFacade,
    editionFeatureService: EditionFeatureService
  ) {
    const treeBuilderFactory = new SessionTreeBuilderFactory(this.sessionSelectorUtilsService, featureTogglesFacade, editionFeatureService);
    this.treeBuilder = treeBuilderFactory.createTreeBuilder();
    this.listBuilder = new SessionListBuilder();
  }

  public getSessionData$(context: ISessionSelectorContext): Observable<ISessionSelectorData> {
    return new ReduxStoreObserver(reduxStoreContainer.reduxStore).whenFetched$<ISessionsStoreState>("sessions").pipe(
      map(({ sessions }) => {
        const sessionsSetWithPermissions = this.sessionSelectorUtilsService.fillSessionWithPermissions(sessions.items);

        this.treeBuilder.setSessionIdMap(sessions.map);
        this.tree = this.treeBuilder.buildTree(sessionsSetWithPermissions, context);
        this.list = this.listBuilder.buildList(this.tree);

        return { tree: this.tree, list: this.list };
      })
    );
  }

  // The sessions are loaded from redux and are loaded before initialisation of session-selector as they are fetched in goals/form.ts
  public isLoading$(): Observable<boolean> {
    return this.usersFacade.getState().isLoading$(HttpActions.get);
  }
}
